import axios from "./axiosInstance";
import {TrimPoint} from "../types/editor";
import ClipForm from "../components/ClipsComponents/ClipForm/ClipForm";
import {FormClip} from "../types/clipTypes";
import {ClipDescription} from "../types/clipTypes";
const baseUrl = process.env.REACT_APP_BASE_URL+"/clip";

export async function deleteClip(id: string){
    const response = await axios.delete(`${baseUrl}/${id}`);
    return response.data
}

export const updateClip = async (clipId: any, ratingValue: number | null) => {
    await axios.put(process.env.REACT_APP_BASE_URL + `/clip/updateClip/${clipId}`, {manual_rating: ratingValue});
}

export const updateClipTags = async (clipId: any, tags: string[], contentType: 'clip'|'highlight'|'socialClip') => {
    await axios.put(process.env.REACT_APP_BASE_URL + `/clip/updateClipTags/${clipId}`, {tags, content_type: contentType});
}

export const getClipByEventId = async (eventId: string) => {
    const response = await axios.get(`${process.env.REACT_APP_BASE_URL + `/clip/clipsLastJob/${eventId}`}`);
    return response.data;
}

export const getUrlClipForDownload = async (jobId: string ,trimPoints: TrimPoint, sessionToken?: string) => {
    const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/clip/clipDownload/${jobId}`,
        {trimPoints: trimPoints, sessionToken }
    );
    return response.data;
};

export const getClipFormOptions = async () => {
    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/clip/clipFormOptions`);
    return response.data;
}

export async function createClip(clip: FormClip) {
    const response = await axios.post(baseUrl, clip);
    return response.data
}

export const regenerateLLMDescription = async (videoContentId: string, language: string, style: string): Promise<ClipDescription> => {
    const response =  await axios.post(`${baseUrl}/descriptions/generate/${videoContentId}`, {language, style});
    return response.data
}

export const updateLLMDescription = async (videoContentId: string, descriptions: ClipDescription[]): Promise<ClipDescription> => {
    const response =  await axios.put(`${baseUrl}/descriptions/update/${videoContentId}`, {descriptions});
    return response.data
}
